(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [
		{name:"index_atlas_1", frames: [[0,255,114,49],[251,153,120,49],[0,153,249,49],[0,102,268,49],[0,204,238,49],[275,51,159,49],[270,102,166,49],[0,0,353,49],[0,51,273,49],[355,0,123,49],[240,204,225,49],[373,153,116,49]]}
];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.CachedBmp_14 = function() {
	this.initialize(img.CachedBmp_14);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,3890,1050);


(lib.CachedBmp_13 = function() {
	this.initialize(img.CachedBmp_13);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,3377,802);


(lib.CachedBmp_12 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_11 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_10 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_9 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_8 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_7 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_6 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_5 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_4 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_3 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_2 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_1 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.size_1920x1080 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-960,540).lineTo(-960,-540).lineTo(960,-540).lineTo(960,540).closePath();
	this.shape.setTransform(960,540);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.size_1920x1080, new cjs.Rectangle(0,0,1920,1080), null);


(lib.size_90x90 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-45,45).lineTo(-45,-45).lineTo(45,-45).lineTo(45,45).closePath();
	this.shape.setTransform(45,45);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.size_90x90, new cjs.Rectangle(0,0,90,90), null);


(lib.logoNone = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(89.6,51.6).lineTo(88.4,51.1).lineTo(88.9,50.2).curveTo(89.6,50.6,90.6,50.6).lineTo(91,50.6).lineTo(91.5,50.5).lineTo(91.9,50.1).lineTo(92,49.7).curveTo(92,49.2,91.6,48.9).lineTo(90.8,48.7).lineTo(89.9,48.9).lineTo(89.4,48.5).lineTo(90.7,46.9).curveTo(88.9,46.6,87.6,46).curveTo(86.4,45.4,85.2,44.2).curveTo(83.9,42.4,83.6,41.4).curveTo(83.1,40.1,83.1,38).curveTo(83.1,36.4,83.7,34.6).curveTo(84.3,33,85.4,31.8).curveTo(86.6,30.6,88.1,30).curveTo(89.7,29.2,91.6,29.2).curveTo(93.2,29.2,94.9,29.9).curveTo(96.3,30.3,97.6,31.8).lineTo(95.9,33.1).curveTo(95.1,32.2,94,31.6).curveTo(93,31.1,91.6,31.1).curveTo(90.1,31.1,89,31.6).curveTo(87.5,32.6,87.1,33.2).curveTo(86,34.2,85.7,35.4).curveTo(85.2,36.6,85.2,38).curveTo(85.2,39.6,85.7,40.8).curveTo(86,42,87.1,43).curveTo(87.8,44,89,44.5).curveTo(90.1,45,91.6,45).curveTo(93.2,45,94.3,44.5).curveTo(95.9,43.5,96.5,42.7).lineTo(97.9,44).curveTo(96.8,45.5,95.2,46.2).curveTo(93.4,46.9,91.6,46.9).lineTo(90.9,48).lineTo(91.3,48).lineTo(91.6,47.8).lineTo(92.4,48).lineTo(92.9,48.4).lineTo(93.4,48.8).lineTo(93.6,49.6).lineTo(93.4,50.6).lineTo(92.6,51.2).lineTo(91.7,51.6).closePath().moveTo(164.2,46.8).curveTo(163.6,46.8,162.8,46.3).curveTo(162.2,46.2,161.6,45.6).curveTo(161.3,45.5,160.5,44.6).lineTo(162.2,43.2).curveTo(162.8,44.2,163.7,44.6).curveTo(164.8,45,165.8,45).lineTo(167.2,44.9).lineTo(168.3,44.2).lineTo(169.1,43.4).curveTo(169.5,42.9,169.5,42.2).curveTo(169.5,41.3,169.1,40.9).curveTo(169,40.4,168.4,40).lineTo(163.5,38).lineTo(162.1,37.2).lineTo(161.2,35.9).curveTo(160.9,35.1,160.8,34.1).curveTo(160.8,33.2,161.4,32).curveTo(161.9,31,162.7,30.5).lineTo(164.4,29.5).lineTo(166.6,29.2).lineTo(169.3,29.7).curveTo(170.7,30.2,171.4,31.3).lineTo(169.7,32.6).curveTo(169.3,32,168.4,31.5).lineTo(166.6,31.1).lineTo(165.3,31.3).lineTo(164.2,31.7).lineTo(163.3,32.6).lineTo(163.1,34).lineTo(163.2,35).lineTo(163.8,35.7).lineTo(165,36.4).lineTo(168.4,37.7).curveTo(169.6,38.2,170,38.6).curveTo(170.7,39,171.1,39.9).curveTo(171.7,40.8,171.7,42.1).curveTo(171.7,42.9,171.1,44.2).curveTo(170.5,45.1,169.8,45.8).curveTo(169.1,46.3,167.9,46.6).curveTo(167.2,46.8,165.7,46.9).closePath().moveTo(114.1,46.2).curveTo(112.3,45.5,111.3,44.4).curveTo(110.1,43.2,109.5,41.6).curveTo(108.8,40.1,108.7,38).curveTo(108.8,36.1,109.5,34.6).curveTo(110.1,33,111.3,31.7).curveTo(112.8,30.5,114.1,29.9).curveTo(115.7,29.2,117.6,29.2).curveTo(119.3,29.2,121.2,29.9).curveTo(122.9,30.7,123.9,31.7).curveTo(125,32.8,125.7,34.6).curveTo(126.3,36.2,126.4,38).curveTo(126.3,39.8,125.7,41.6).curveTo(124.9,43.4,123.9,44.4).curveTo(123.1,45.2,121.2,46.2).curveTo(119.8,46.9,117.6,46.9).curveTo(115.3,46.9,114.1,46.2).closePath().moveTo(114.9,31.6).curveTo(113.4,32.2,112.9,33.1).curveTo(111.8,34.1,111.5,35.3).curveTo(111,36.5,111,38).curveTo(111,39.6,111.5,40.8).curveTo(111.8,42,112.9,43).curveTo(113.4,43.9,114.9,44.5).curveTo(116,45,117.6,45).curveTo(119.2,45,120.3,44.5).curveTo(121.4,44,122.4,43).curveTo(123.1,42.3,123.8,40.8).curveTo(124.2,39.6,124.2,38).curveTo(124.2,36.5,123.8,35.3).curveTo(123.1,33.9,122.4,33.1).curveTo(121.4,32.1,120.3,31.6).curveTo(119.2,31.1,117.6,31.1).curveTo(116,31.1,114.9,31.6).closePath().moveTo(-4.5,46.8).curveTo(-5.2,46.8,-5.9,46.3).lineTo(-7.2,45.6).lineTo(-8.2,44.6).lineTo(-6.6,43.2).curveTo(-6,44.2,-4.9,44.6).curveTo(-3.9,45,-3,45).lineTo(-1.6,44.9).lineTo(-0.5,44.2).lineTo(0.4,43.4).curveTo(0.7,42.9,0.7,42.2).lineTo(0.5,40.9).lineTo(-0.3,40).curveTo(-1.1,39.5,-1.8,39.4).lineTo(-5.4,38).lineTo(-6.7,37.2).lineTo(-7.5,35.9).lineTo(-7.8,34.1).curveTo(-7.8,32.9,-7.3,32).curveTo(-7,31.2,-6.1,30.5).curveTo(-5.2,29.9,-4.2,29.5).lineTo(-2.1,29.2).curveTo(-0.6,29.2,0.5,29.7).curveTo(1.8,30.2,2.6,31.3).lineTo(1,32.6).curveTo(0.5,31.9,-0.3,31.5).curveTo(-1.3,31.1,-2.1,31.1).lineTo(-3.5,31.3).lineTo(-4.6,31.7).lineTo(-5.5,32.6).lineTo(-5.7,34).lineTo(-5.6,35).lineTo(-4.9,35.7).lineTo(-3.9,36.4).lineTo(-0.3,37.7).lineTo(1.4,38.6).curveTo(2.1,39,2.5,39.9).curveTo(2.8,40.9,2.8,42.1).curveTo(2.8,43.2,2.4,44.2).curveTo(1.7,45.1,1,45.8).curveTo(0.3,46.3,-0.9,46.6).curveTo(-1.6,46.8,-3.1,46.9).closePath().moveTo(-99.6,46.2).curveTo(-101.5,45.2,-102.3,44.4).curveTo(-103.3,43.4,-104.1,41.6).curveTo(-104.8,39.8,-104.8,38).curveTo(-104.8,36.2,-104.1,34.6).curveTo(-103.4,32.8,-102.3,31.7).curveTo(-101.3,30.7,-99.6,29.9).curveTo(-97.7,29.2,-96,29.2).curveTo(-94.3,29.2,-92.5,29.9).curveTo(-91.1,30.5,-89.6,31.7).curveTo(-88.4,33,-87.9,34.6).curveTo(-87.2,36.1,-87.2,38).curveTo(-87.2,40.1,-87.9,41.6).curveTo(-88.6,43.2,-89.6,44.4).curveTo(-90.8,45.5,-92.5,46.2).curveTo(-93.9,46.9,-96,46.9).curveTo(-98.2,46.9,-99.6,46.2).closePath().moveTo(-98.7,31.6).curveTo(-99.9,32.1,-100.8,33.1).curveTo(-101.5,33.9,-102.2,35.3).curveTo(-102.7,36.5,-102.7,38).curveTo(-102.7,39.6,-102.2,40.8).curveTo(-101.5,42.3,-100.8,43).curveTo(-99.9,44,-98.7,44.5).curveTo(-97.6,45,-96,45).curveTo(-94.4,45,-93.4,44.5).curveTo(-92,43.9,-91.2,43).curveTo(-90.3,42,-89.9,40.8).curveTo(-89.4,39.6,-89.4,38).curveTo(-89.4,36.5,-89.9,35.3).curveTo(-90.3,34.1,-91.2,33.1).curveTo(-92,32.2,-93.4,31.6).curveTo(-94.4,31.1,-96,31.1).curveTo(-97.6,31.1,-98.7,31.6).closePath().moveTo(138.6,46.5).lineTo(138.6,29.7).lineTo(149.2,29.7).lineTo(149.2,31.5).lineTo(140.7,31.5).lineTo(140.7,36.8).lineTo(148.5,36.8).lineTo(148.5,38.7).lineTo(140.7,38.7).lineTo(140.7,44.6).lineTo(149.5,44.6).lineTo(149.5,46.5).closePath().moveTo(70.5,46.5).lineTo(68.7,42.4).lineTo(60.4,42.4).lineTo(58.6,46.5).lineTo(56.3,46.5).lineTo(63.7,29.7).lineTo(65.6,29.7).lineTo(72.8,46.5).closePath().moveTo(61.1,40.6).lineTo(68,40.6).lineTo(64.6,32.3).closePath().moveTo(42.6,46.5).lineTo(32.9,32.5).lineTo(32.9,46.5).lineTo(30.7,46.5).lineTo(30.7,29.7).lineTo(33.3,29.7).lineTo(43,43.6).lineTo(43.1,43.6).lineTo(43.1,29.7).lineTo(45.1,29.7).lineTo(45.1,46.5).closePath().moveTo(-20.6,46.5).lineTo(-22.3,42.4).lineTo(-30.8,42.4).lineTo(-32.5,46.5).lineTo(-34.7,46.5).lineTo(-27.3,29.7).lineTo(-25.4,29.7).lineTo(-18.3,46.5).closePath().moveTo(-30,40.6).lineTo(-23,40.6).lineTo(-26.4,32.3).closePath().moveTo(-59.6,46.5).lineTo(-59.6,29.7).lineTo(-53.2,29.7).lineTo(-51.5,29.9).lineTo(-49.6,30.5).curveTo(-48.9,30.7,-47.9,31.6).lineTo(-46.4,33.1).curveTo(-45.5,34.7,-45.4,35.3).curveTo(-45,36.5,-45,38).curveTo(-45,39.6,-45.4,40.8).curveTo(-45.7,41.9,-46.4,43).lineTo(-47.9,44.6).lineTo(-49.6,45.8).lineTo(-53.2,46.5).closePath().moveTo(-57.7,44.6).lineTo(-54,44.6).lineTo(-51.2,44.2).curveTo(-50,43.9,-49.1,43).curveTo(-48.1,42.3,-47.6,41).curveTo(-47.1,39.3,-47.1,38).curveTo(-47.1,36.8,-47.6,35.1).curveTo(-48.3,33.7,-49.1,33.1).curveTo(-50.3,32.1,-51.2,31.8).lineTo(-54,31.5).lineTo(-57.7,31.5).closePath().moveTo(-122.7,46.5).lineTo(-122.7,31.5).lineTo(-128.3,31.5).lineTo(-128.3,29.7).lineTo(-115.2,29.7).lineTo(-115.2,31.5).lineTo(-120.8,31.5).lineTo(-120.8,46.5).closePath().moveTo(-145.2,46.5).lineTo(-145.2,29.7).lineTo(-143.3,29.7).lineTo(-143.3,44.6).lineTo(-135.5,44.6).lineTo(-135.5,46.5).closePath().moveTo(-158.7,46.5).lineTo(-160.4,42.4).lineTo(-168.9,42.4).lineTo(-170.6,46.5).lineTo(-172.9,46.5).lineTo(-165.5,29.7).lineTo(-163.5,29.7).lineTo(-156.5,46.5).closePath().moveTo(-168.2,40.6).lineTo(-161.2,40.6).lineTo(-164.6,32.3).closePath().moveTo(113.6,28.2).lineTo(113.9,27.2).lineTo(114.3,26.5).lineTo(115.1,25.9).lineTo(115.9,25.8).lineTo(117,25.9).lineTo(118.7,26.5).lineTo(119.3,26.6).lineTo(120.1,26.4).lineTo(120.4,25.6).lineTo(121.5,25.6).lineTo(121.3,26.5).lineTo(120.9,27.2).lineTo(120.3,27.9).lineTo(119.3,28.1).lineTo(118.3,28).lineTo(116.7,27.2).lineTo(115.8,27.1).lineTo(115.1,27.5).lineTo(114.7,28.2).closePath().moveTo(186,-5.4).curveTo(179.6,-12,179.6,-25.1).curveTo(179.5,-37.8,186.7,-44.9).curveTo(193.2,-51.6,204,-51.6).curveTo(207.5,-51.6,211.8,-50.5).curveTo(216.1,-49.3,216.7,-49.4).curveTo(217.8,-49.4,218.5,-50.9).lineTo(219.6,-50.9).lineTo(220.1,-35.8).lineTo(218.5,-35.8).curveTo(214.7,-49.4,203.9,-49.4).curveTo(189.5,-49.4,189.5,-25.3).curveTo(189.5,-13.8,193.2,-7.7).curveTo(196.9,-1.6,204,-1.6).curveTo(210.3,-1.6,212.3,-6.4).lineTo(212.3,-18.6).lineTo(206.2,-18.6).lineTo(206.2,-20.7).lineTo(225.7,-20.7).lineTo(225.7,-18.6).lineTo(221.3,-18.6).lineTo(221.3,-0.1).lineTo(220.2,-0.1).curveTo(219.2,-2,217.4,-2).curveTo(216.7,-2,211.8,-0.7).curveTo(207,0.8,203.4,0.8).curveTo(192.1,0.7,186,-5.4).closePath().moveTo(160.7,-1.6).curveTo(158.8,-3.9,158.8,-9.2).lineTo(158.8,-17.9).curveTo(158.8,-21.6,157.1,-23.3).curveTo(155.3,-25.2,150.9,-25.2).lineTo(146.2,-25.2).lineTo(146.2,-2.1).lineTo(153,-2.1).lineTo(153,-0).lineTo(131.2,-0).lineTo(131.2,-2.1).lineTo(136.9,-2.1).lineTo(136.9,-48.7).lineTo(131.2,-48.7).lineTo(131.2,-50.9).lineTo(149.5,-50.9).curveTo(159.9,-50.9,164.4,-48.7).curveTo(170.2,-46,170.2,-38.8).curveTo(170.2,-32.7,166.5,-29.6).curveTo(163.2,-27,156.4,-26.5).lineTo(156.4,-26.3).curveTo(162.9,-25.4,165.5,-22.9).curveTo(168.3,-20,168.3,-13.9).lineTo(168.3,-8).curveTo(168.3,-5.4,168.8,-4.5).curveTo(169.4,-3.1,171.3,-3.1).curveTo(172.8,-3.1,173.5,-4.6).curveTo(174,-5.7,174.9,-9.8).lineTo(176.4,-9.6).curveTo(175.6,-4.3,174.5,-2.5).curveTo(172.6,0.8,167.8,0.8).curveTo(162.7,0.7,160.7,-1.6).closePath().moveTo(146.2,-27.3).lineTo(148,-27.3).curveTo(154.4,-27.3,157.2,-29.9).curveTo(160.2,-32.6,160.2,-38.7).curveTo(160.2,-44.6,157.2,-46.9).curveTo(154.7,-48.7,148.3,-48.7).lineTo(146.2,-48.7).closePath().moveTo(26.7,0.3).lineTo(-2,-46.9).lineTo(-2,-2.1).lineTo(3.1,-2.1).lineTo(3.1,-0).lineTo(-9.5,-0).lineTo(-9.5,-2.1).lineTo(-4.5,-2.1).lineTo(-4.5,-48.7).lineTo(-9.5,-48.7).lineTo(-9.5,-50.9).lineTo(6.4,-50.9).lineTo(28.4,-14.3).lineTo(28.4,-48.7).lineTo(23.3,-48.7).lineTo(23.3,-50.9).lineTo(35.9,-50.9).lineTo(35.9,-48.7).lineTo(30.9,-48.7).lineTo(30.9,0.3).closePath().moveTo(-121.4,0.3).lineTo(-150,-46.9).lineTo(-150,-2.1).lineTo(-145,-2.1).lineTo(-145,-0).lineTo(-157.6,-0).lineTo(-157.6,-2.1).lineTo(-152.5,-2.1).lineTo(-152.5,-48.7).lineTo(-157.6,-48.7).lineTo(-157.6,-50.9).lineTo(-141.6,-50.9).lineTo(-119.7,-14.3).lineTo(-119.7,-48.7).lineTo(-124.7,-48.7).lineTo(-124.7,-50.9).lineTo(-112,-50.9).lineTo(-112,-48.7).lineTo(-117.1,-48.7).lineTo(-117.1,0.3).closePath().moveTo(86.7,-0).lineTo(86.7,-2.1).lineTo(92.2,-2.1).lineTo(92.2,-48.7).lineTo(86.7,-48.7).lineTo(86.7,-50.9).lineTo(123.1,-50.9).lineTo(123.8,-37.1).lineTo(122.1,-37.1).curveTo(120.7,-44.4,117.2,-46.7).curveTo(114.4,-48.8,107.1,-48.7).lineTo(101.3,-48.7).lineTo(101.3,-27).lineTo(104.8,-27).curveTo(108.9,-27.1,110.7,-29).curveTo(112.5,-31,113.3,-36.4).lineTo(114.9,-36.4).lineTo(114.9,-14.9).lineTo(113.2,-14.9).curveTo(112.2,-20.9,110.5,-22.7).curveTo(108.6,-24.7,104.1,-24.7).lineTo(101.3,-24.7).lineTo(101.3,-2.1).lineTo(107.7,-2.1).curveTo(115.4,-2.1,119.1,-5.2).curveTo(122.6,-8.2,124,-15.2).lineTo(125.5,-15.2).lineTo(124.9,-0).closePath().moveTo(40.7,-0).lineTo(40.7,-2.1).lineTo(46.5,-2.1).lineTo(46.5,-48.7).lineTo(40.7,-48.7).lineTo(40.7,-50.9).lineTo(58.5,-50.9).curveTo(68.4,-50.9,73.2,-48.3).curveTo(78.5,-45.4,78.5,-38.8).curveTo(78.5,-28.9,67.3,-27).lineTo(67.3,-26.9).curveTo(73.8,-26,77.4,-22.9).curveTo(81.1,-19.6,81.1,-14.4).curveTo(81.1,-6.4,74.6,-2.8).curveTo(69.2,-0,58.2,-0).closePath().moveTo(55.8,-2.1).lineTo(59.2,-2.1).curveTo(65.8,-2.1,68.4,-5).curveTo(71,-7.6,71,-14.2).curveTo(71,-20.1,68.4,-22.6).curveTo(65.7,-25.3,59.1,-25.3).lineTo(55.8,-25.3).closePath().moveTo(55.8,-27.4).lineTo(57.6,-27.4).curveTo(64,-27.4,66.6,-30).curveTo(69.1,-32.6,69.1,-38.6).curveTo(69.1,-44.3,66.6,-46.5).curveTo(64.2,-48.7,58.1,-48.7).lineTo(55.8,-48.7).closePath().moveTo(-54.7,-0).lineTo(-54.7,-2.1).lineTo(-49.4,-2.1).lineTo(-49.4,-48.7).lineTo(-54.7,-48.7).lineTo(-54.7,-50.9).lineTo(-18.3,-50.9).lineTo(-17.6,-37.1).lineTo(-19.3,-37.1).curveTo(-20.7,-44.4,-24.2,-46.7).curveTo(-27.2,-48.8,-34.4,-48.7).lineTo(-40.2,-48.7).lineTo(-40.2,-27).lineTo(-36.6,-27).curveTo(-32.5,-27.1,-30.8,-29).curveTo(-29,-31,-28.1,-36.4).lineTo(-26.5,-36.4).lineTo(-26.5,-14.9).lineTo(-28.2,-14.9).curveTo(-29.2,-20.9,-31,-22.7).curveTo(-32.8,-24.7,-37.3,-24.7).lineTo(-40.2,-24.7).lineTo(-40.2,-2.1).lineTo(-33.6,-2.1).curveTo(-26.1,-2.1,-22.5,-5.2).curveTo(-18.9,-8.2,-17.5,-15.2).lineTo(-16,-15.2).lineTo(-16.5,-0).closePath().moveTo(-107.4,-0).lineTo(-107.4,-2.1).lineTo(-101.6,-2.1).lineTo(-101.6,-48.7).lineTo(-107.4,-48.7).lineTo(-107.4,-50.9).lineTo(-88.4,-50.9).curveTo(-74.6,-50.9,-67.7,-45.4).curveTo(-60.3,-39.5,-60.3,-26.3).curveTo(-60.3,-11.9,-68.8,-5.4).curveTo(-76.2,-0,-90.3,-0).closePath().moveTo(-92.2,-2.1).lineTo(-89.2,-2.1).curveTo(-79.4,-2.1,-74.8,-8).curveTo(-70.3,-13.9,-70.3,-26).curveTo(-70.3,-39.3,-75.1,-44.3).curveTo(-79.6,-48.7,-90.4,-48.7).lineTo(-92.2,-48.7).closePath().moveTo(-182.8,-0).lineTo(-182.8,-2.1).lineTo(-177.7,-2.1).lineTo(-177.7,-48.7).lineTo(-182.8,-48.7).lineTo(-182.8,-50.9).lineTo(-163.4,-50.9).lineTo(-163.4,-48.7).lineTo(-168.6,-48.7).lineTo(-168.6,-2.1).lineTo(-163.4,-2.1).lineTo(-163.4,-0).closePath().moveTo(-225.7,-0).lineTo(-225.7,-2.1).lineTo(-220.4,-2.1).lineTo(-220.4,-48.7).lineTo(-225.7,-48.7).lineTo(-225.7,-50.9).lineTo(-203.5,-50.9).lineTo(-203.5,-48.7).lineTo(-211.2,-48.7).lineTo(-211.2,-2.1).lineTo(-206.3,-2.1).curveTo(-198.6,-2.1,-195,-5.3).curveTo(-191.7,-8.4,-189.9,-16.5).lineTo(-188.1,-16.5).lineTo(-189,-0).closePath();
	this.shape.setTransform(225.7,51.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,451.4,103.2);


(lib.lines2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.CachedBmp_14();
	this.instance.setTransform(-1,179,0.5,0.5);

	this.instance_1 = new lib.CachedBmp_13();
	this.instance_1.setTransform(92.1,847,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1,179,1945,1069);


(lib.lines = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#B19D8B").setStrokeStyle(0.7).moveTo(925.6,-187.6).lineTo(39.9,-602.6).lineTo(7.6,-617.8).lineTo(-535.6,-363.6).moveTo(-653.8,617.9).lineTo(-72,345.3).lineTo(490.2,608.6).moveTo(761.7,608.6).lineTo(-72.3,217.9).lineTo(-925.5,617.9);
	this.shape.setTransform(1018.15,629.6253);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill().beginStroke("#B4292B").setStrokeStyle(2).moveTo(557.8,-261.4).lineTo(500.2,-234.4).lineTo(68.3,-32).moveTo(-497.8,233.2).lineTo(-557.8,261.4);
	this.shape_1.setTransform(557.8251,261.3751);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1,-1,1945.7,1249.5);


(lib.vertical = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// vertical
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,1,1).moveTo(0,-8).lineTo(0,8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.vertical, new cjs.Rectangle(-1,-9,2,18), null);


(lib.square = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// square
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-4,4).lineTo(-4,-4).lineTo(4,-4).lineTo(4,4).closePath();

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.square, new cjs.Rectangle(-4,-4,8,8), null);


(lib.ball = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// ball
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-2.8,2.9).curveTo(-4,1.7,-4,0).curveTo(-4,-1.6,-2.8,-2.8).curveTo(-1.6,-4,0,-4).curveTo(1.6,-4,2.8,-2.8).curveTo(4,-1.6,4,0).curveTo(4,1.7,2.8,2.9).curveTo(1.6,4,0,4).curveTo(-1.6,4,-2.8,2.9).closePath();

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ball, new cjs.Rectangle(-4,-4,8,8), null);


(lib.pseudo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// pseudo
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0.498)").beginStroke().moveTo(-67.4,30).lineTo(-67.4,-30).lineTo(67.4,-30).lineTo(67.4,30).closePath();
	this.shape.setTransform(67.4,30);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.pseudo, new cjs.Rectangle(0,0,134.8,60), null);


(lib.arrow_up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// arrow
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-22.6,11.3).lineTo(-0.1,-11.3).lineTo(22.6,11.3).closePath();
	this.shape.setTransform(0,11.325);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.arrow_up, new cjs.Rectangle(-22.6,0,45.2,22.7), null);


(lib.solid = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#CAAF6F").setStrokeStyle(4,0,1).moveTo(-960,0).lineTo(960,0);
	this.shape.setTransform(960,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.solid, new cjs.Rectangle(-2,-2,1924,4), null);


(lib.gradient = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#5BC3BE","#1F4F6E"],[0,1],-680,0,680,0).beginStroke().moveTo(-680,2).lineTo(-680,-2).lineTo(680,-2).lineTo(680,2).closePath();
	this.shape.setTransform(680,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.gradient, new cjs.Rectangle(0,-2,1360,4), null);


(lib._double = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#666666").setStrokeStyle(2,1,1).moveTo(50,-30).lineTo(-550,-30).moveTo(550,30).lineTo(-250,30);
	this.shape.setTransform(550,30);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib._double, new cjs.Rectangle(-1,-1,1102,62), null);


(lib.logo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// logo
	this.text = new cjs.Text("Before", "200px 'Montserrat Medium'", "#FFFFFF");
	this.text.textAlign = "center";
	this.text.lineHeight = 278;
	this.text.lineWidth = 676;
	this.text.parent = this;
	this.text.setTransform(233.35,2);

	this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.logo, new cjs.Rectangle(-106.5,0,679.7,557.6), null);


(lib.button = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// pseudo
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-64,64).lineTo(-64,-64).lineTo(64,-64).lineTo(64,64).closePath();
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(3).to({_off:false},0).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-64,-64,128,128);


(lib.title = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// vertical
	this.instance = new lib.vertical();
	this.instance.setTransform(1215.7,13);
	this.instance.visible = false;

	this.instance_1 = new lib.vertical();
	this.instance_1.setTransform(1071.5,13);
	this.instance_1.visible = false;

	this.instance_2 = new lib.vertical();
	this.instance_2.setTransform(833.4,13);
	this.instance_2.visible = false;

	this.instance_3 = new lib.vertical();
	this.instance_3.setTransform(634.5,13);
	this.instance_3.visible = false;

	this.instance_4 = new lib.vertical();
	this.instance_4.setTransform(1410.4,13);
	this.instance_4.visible = false;

	this.instance_5 = new lib.vertical();
	this.instance_5.setTransform(450.8,13);
	this.instance_5.visible = false;

	this.instance_6 = new lib.vertical();
	this.instance_6.setTransform(273.8,13);
	this.instance_6.visible = false;

	this.instance_7 = new lib.vertical();
	this.instance_7.setTransform(88,13);
	this.instance_7.visible = false;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// square
	this.instance_8 = new lib.square();
	this.instance_8.setTransform(1215.7,13);
	this.instance_8.visible = false;

	this.instance_9 = new lib.square();
	this.instance_9.setTransform(1071.5,13);
	this.instance_9.visible = false;

	this.instance_10 = new lib.square();
	this.instance_10.setTransform(833.4,13);
	this.instance_10.visible = false;

	this.instance_11 = new lib.square();
	this.instance_11.setTransform(1410.4,13);
	this.instance_11.visible = false;

	this.instance_12 = new lib.square();
	this.instance_12.setTransform(634.5,13);
	this.instance_12.visible = false;

	this.instance_13 = new lib.square();
	this.instance_13.setTransform(450.8,13);
	this.instance_13.visible = false;

	this.instance_14 = new lib.square();
	this.instance_14.setTransform(273.8,13);
	this.instance_14.visible = false;

	this.instance_15 = new lib.square();
	this.instance_15.setTransform(88,13);
	this.instance_15.visible = false;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8}]}).wait(1));

	// ball
	this.instance_16 = new lib.ball();
	this.instance_16.setTransform(1447.2,12.05);

	this.instance_17 = new lib.ball();
	this.instance_17.setTransform(1357.95,12.05);

	this.instance_18 = new lib.ball();
	this.instance_18.setTransform(1195.7,12.05);

	this.instance_19 = new lib.ball();
	this.instance_19.setTransform(1087.45,12.05);

	this.instance_20 = new lib.ball();
	this.instance_20.setTransform(976.2,12.05);

	this.instance_21 = new lib.ball();
	this.instance_21.setTransform(771.7,12.05);

	this.instance_22 = new lib.ball();
	this.instance_22.setTransform(681.95,12.05);

	this.instance_23 = new lib.ball();
	this.instance_23.setTransform(516.2,12.05);

	this.instance_24 = new lib.ball();
	this.instance_24.setTransform(366.45,12.05);

	this.instance_25 = new lib.ball();
	this.instance_25.setTransform(225.95,12.05);

	this.instance_26 = new lib.ball();
	this.instance_26.setTransform(72.45,12.05);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_26},{t:this.instance_25},{t:this.instance_24},{t:this.instance_23},{t:this.instance_22},{t:this.instance_21},{t:this.instance_20},{t:this.instance_19},{t:this.instance_18},{t:this.instance_17},{t:this.instance_16}]}).wait(1));

	// title
	this.instance_27 = new lib.CachedBmp_12();
	this.instance_27.setTransform(1462.1,0,0.5,0.5);

	this.instance_28 = new lib.CachedBmp_11();
	this.instance_28.setTransform(1372.3,0,0.5,0.5);

	this.instance_29 = new lib.CachedBmp_10();
	this.instance_29.setTransform(84.85,0,0.5,0.5);

	this.instance_30 = new lib.CachedBmp_9();
	this.instance_30.setTransform(1209.8,0,0.5,0.5);

	this.instance_31 = new lib.CachedBmp_8();
	this.instance_31.setTransform(382.3,0,0.5,0.5);

	this.instance_32 = new lib.CachedBmp_7();
	this.instance_32.setTransform(1101.8,0,0.5,0.5);

	this.instance_33 = new lib.CachedBmp_6();
	this.instance_33.setTransform(990.25,0,0.5,0.5);

	this.instance_34 = new lib.CachedBmp_5();
	this.instance_34.setTransform(785.75,0,0.5,0.5);

	this.instance_35 = new lib.CachedBmp_4();
	this.instance_35.setTransform(531.2,0,0.5,0.5);

	this.instance_36 = new lib.CachedBmp_3();
	this.instance_36.setTransform(696.15,0,0.5,0.5);

	this.instance_37 = new lib.CachedBmp_2();
	this.instance_37.setTransform(238.75,0,0.5,0.5);

	this.instance_38 = new lib.CachedBmp_1();
	this.instance_38.setTransform(-0.6,0,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_38},{t:this.instance_37},{t:this.instance_36},{t:this.instance_35},{t:this.instance_34},{t:this.instance_33},{t:this.instance_32},{t:this.instance_31},{t:this.instance_30},{t:this.instance_29},{t:this.instance_28},{t:this.instance_27}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.title, new cjs.Rectangle(-0.6,0,1519.6999999999998,24.5), null);


(lib.effect_up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {start:1,complete:10,end:19};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}
	this.frame_9 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}
	this.frame_19 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(10).call(this.frame_19).wait(1));

	// effect
	this.instance = new lib.arrow_up();
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({y:-30},4).to({y:-22.65},2).to({y:-30},2).wait(1).to({y:0},9).wait(1));

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-22.6,11.3).lineTo(-0.1,-11.3).lineTo(22.6,11.3).closePath();
	this.shape.setTransform(0,11.325);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(20));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-22.6,-30,45.2,52.7);


(lib.background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line_solid
	this.instance = new lib.solid();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// line_gradient
	this.instance_1 = new lib.gradient();
	this.instance_1.setTransform(560,0);
	this.instance_1.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// line_double
	this.instance_2 = new lib._double();
	this.instance_2.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// background
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#B09C88").beginStroke().moveTo(-960,40).lineTo(-960,-40).lineTo(960,-40).lineTo(960,40).closePath();
	this.shape.setTransform(960,40);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.background, new cjs.Rectangle(-2,-2,1924,82), null);


(lib.logo_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {none:1,small:2,medium:3,large:4};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(5));

	// background
	this.instance = new lib.logoNone("synched",0);
	this.instance.setTransform(125.25,42.55,0.2339,0.2339,0,0,0,225.8,51.8);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2).to({_off:false},0).wait(1).to({regX:225.9,scaleX:0.3889,scaleY:0.3889,x:125.3},0).wait(1).to({regX:225.8,regY:51.7,scaleX:0.5436,scaleY:0.5436,x:125.25,y:42.5},0).wait(1));

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-110,40).lineTo(-110,-40).lineTo(110,-40).lineTo(110,40).closePath();
	this.shape.setTransform(125.0005,40,1.1364,1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(5));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,250,80);


(lib.background_dynamic = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {frame01:1,frame02:2,frame03:3,frame04:4,frame05:5,frame06:6,frame07:7,frame08:8,frame09:9,frame10:10,frame11:11,frame12:12,frame13:13};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(14));

	// background
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#DFD9D3").beginStroke().moveTo(-960,540).lineTo(-960,-540).lineTo(960,-540).lineTo(960,540).closePath();
	this.shape.setTransform(960,540);

	this.instance = new lib.lines("synched",0);
	this.instance.setTransform(957.6,542.1,1,1,0,0,0,971.5,542.1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-960,540).lineTo(-960,-540).lineTo(960,-540).lineTo(960,540).closePath();
	this.shape_1.setTransform(960.025,540);

	this.instance_1 = new lib.lines2("synched",0);
	this.instance_1.setTransform(957.6,542.1,1,1,0,0,0,971.5,542.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape}]},2).to({state:[{t:this.shape_1},{t:this.instance}]},1).to({state:[{t:this.shape},{t:this.instance}]},1).to({state:[{t:this.shape_1},{t:this.instance}]},1).to({state:[{t:this.shape_1},{t:this.instance_1}]},1).to({state:[{t:this.shape_1},{t:this.instance}]},1).to({state:[{t:this.shape_1},{t:this.instance}]},1).to({state:[{t:this.shape_1},{t:this.instance}]},1).to({state:[{t:this.shape_1},{t:this.instance}]},1).to({state:[{t:this.shape_1},{t:this.instance}]},1).to({state:[{t:this.shape_1},{t:this.instance}]},1).to({state:[{t:this.shape_1},{t:this.instance}]},1).wait(1));

	// size
	this.instance_2 = new lib.size_1920x1080();

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(14));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-14.9,-1,1945.7,1249.5);


(lib.content_frame_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"start":1,"complete":30,"end":59};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectStart('index', 'before');
	}
	this.frame_29 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectComplete('index', 'before');
	}
	this.frame_59 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectEnd('index', 'before');
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(29).call(this.frame_29).wait(30).call(this.frame_59).wait(1));

	// logo
	this.instance = new lib.logo();
	this.instance.setTransform(726.65,360.1);
	this.instance.alpha = 0;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({alpha:1},28).wait(1).to({alpha:0},29).wait(1));

	// button
	this.btn_start = new lib.button();
	this.btn_start.name = "btn_start";
	this.btn_start.setTransform(952.25,795.4);
	this.btn_start._off = true;
	new cjs.ButtonHelper(this.btn_start, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get(this.btn_start).wait(29).to({_off:false},0).to({_off:true},2).wait(29));

	// menu
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#00FF00").beginStroke().moveTo(-64,64).lineTo(-64,-64).lineTo(64,-64).lineTo(64,64).closePath();
	this.shape.setTransform(952.25,795.4);
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(29).to({_off:false},0).to({_off:true},2).wait(29));

	// size
	this.instance_1 = new lib.size_1920x1080();
	this.instance_1.setTransform(960,540,1,1,0,0,0,960,540);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(60));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1080);


(lib.marker = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"frame01":1,"frame02":2,"frame03":3,"frame04":4,"frame05":5,"frame06":6,"frame07":7,"frame08":8,"frame09":9,"frame10":10};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(11));

	// arrow_up
	this.occ_animate = new lib.effect_up();
	this.occ_animate.name = "occ_animate";
	this.occ_animate.setTransform(38.45,0);
	this.occ_animate._off = true;

	this.timeline.addTween(cjs.Tween.get(this.occ_animate).wait(2).to({_off:false},0).wait(1).to({x:190.95},0).wait(1).to({x:372.4},0).wait(1).to({x:552.8},0).wait(1).to({x:744.15},0).wait(1).to({x:962.7},0).wait(1).to({x:1153.9},0).wait(1).to({x:1323.4},0).wait(1).to({x:1480.8},0).wait(1));

	// size
	this.instance = new lib.size_90x90();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(11));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1503.4,90);


(lib.content_frame_02 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// button
	this.btn_page13 = new lib.button();
	this.btn_page13.name = "btn_page13";
	this.btn_page13.setTransform(1850.8,1039.05,0.5999,0.4688,0,0,0,0.6,0.1);
	new cjs.ButtonHelper(this.btn_page13, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page12 = new lib.button();
	this.btn_page12.name = "btn_page12";
	this.btn_page12.setTransform(1762.85,1039.05,0.6265,0.4688,0,0,0,0.7,0.1);
	new cjs.ButtonHelper(this.btn_page12, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page11 = new lib.button();
	this.btn_page11.name = "btn_page11";
	this.btn_page11.setTransform(1637.4,1039.05,1.2045,0.4688,0,0,0,0.4,0.1);
	new cjs.ButtonHelper(this.btn_page11, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page10 = new lib.button();
	this.btn_page10.name = "btn_page10";
	this.btn_page10.setTransform(1501.9,1039.05,0.7788,0.4688,0,0,0,0.4,0.1);
	new cjs.ButtonHelper(this.btn_page10, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page09 = new lib.button();
	this.btn_page09.name = "btn_page09";
	this.btn_page09.setTransform(1391.85,1039.05,0.8038,0.4688,0,0,0,0.2,0.1);
	new cjs.ButtonHelper(this.btn_page09, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page11_1 = new lib.button();
	this.btn_page11_1.name = "btn_page11_1";
	this.btn_page11_1.setTransform(1830.7,1039.05,0.6351,0.4688,0,0,0,0.5,0.1);
	this.btn_page11_1.visible = false;
	new cjs.ButtonHelper(this.btn_page11_1, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page08 = new lib.button();
	this.btn_page08.name = "btn_page08";
	this.btn_page08.setTransform(1234.8,1039.05,1.5365,0.4688,0,0,0,0.5,0.1);
	new cjs.ButtonHelper(this.btn_page08, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page09_1 = new lib.button();
	this.btn_page09_1.name = "btn_page09_1";
	this.btn_page09_1.setTransform(1539.65,1039.05,0.7874,0.4688,0,0,0,0.5,0.1);
	this.btn_page09_1.visible = false;
	new cjs.ButtonHelper(this.btn_page09_1, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page07 = new lib.button();
	this.btn_page07.name = "btn_page07";
	this.btn_page07.setTransform(1087.35,1039.05,0.6366,0.4688,0,0,0,0.7,0.1);
	new cjs.ButtonHelper(this.btn_page07, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page07_1 = new lib.button();
	this.btn_page07_1.name = "btn_page07_1";
	this.btn_page07_1.setTransform(1214.05,1039.05,1.053,0.4688,0,0,0,0.4,0.1);
	this.btn_page07_1.visible = false;
	new cjs.ButtonHelper(this.btn_page07_1, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page06 = new lib.button();
	this.btn_page06.name = "btn_page06";
	this.btn_page06.setTransform(959.9,1039.05,1.2217,0.4688,0,0,0,0.4,0.1);
	new cjs.ButtonHelper(this.btn_page06, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page05 = new lib.button();
	this.btn_page05.name = "btn_page05";
	this.btn_page05.setTransform(802.1,1039.05,1.0851,0.4688,0,0,0,0.3,0.1);
	new cjs.ButtonHelper(this.btn_page05, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page04 = new lib.button();
	this.btn_page04.name = "btn_page04";
	this.btn_page04.setTransform(655.25,1039.05,1.0351,0.4688,0,0,0,0.3,0.1);
	new cjs.ButtonHelper(this.btn_page04, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page03 = new lib.button();
	this.btn_page03.name = "btn_page03";
	this.btn_page03.setTransform(510.6,1039.05,1.1304,0.4688,0,0,0,0.2,0.1);
	new cjs.ButtonHelper(this.btn_page03, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page02 = new lib.button();
	this.btn_page02.name = "btn_page02";
	this.btn_page02.setTransform(388.55,1039.05,0.6101,0.4688,0,0,0,0.2,0.1);
	new cjs.ButtonHelper(this.btn_page02, 0, 1, 2, false, new lib.button(), 3);

	this.btn_back = new lib.button();
	this.btn_back.name = "btn_back";
	this.btn_back.setTransform(185.4,1040.05,1.9531,0.625,0,0,0,0.2,0.1);
	this.btn_back.visible = false;
	new cjs.ButtonHelper(this.btn_back, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.btn_back},{t:this.btn_page02},{t:this.btn_page03},{t:this.btn_page04},{t:this.btn_page05},{t:this.btn_page06},{t:this.btn_page07_1},{t:this.btn_page07},{t:this.btn_page09_1},{t:this.btn_page08},{t:this.btn_page11_1},{t:this.btn_page09},{t:this.btn_page10},{t:this.btn_page11},{t:this.btn_page12},{t:this.btn_page13}]}).wait(1));

	// marker
	this.occ_marker = new lib.marker();
	this.occ_marker.name = "occ_marker";
	this.occ_marker.setTransform(350,1080);

	this.timeline.addTween(cjs.Tween.get(this.occ_marker).wait(1));

	// marker_slider
	this.occ_marker_slider = new lib.arrow_up();
	this.occ_marker_slider.name = "occ_marker_slider";
	this.occ_marker_slider.setTransform(389.2,1057.35);
	this.occ_marker_slider.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_marker_slider).wait(1));

	// pseudo
	this.instance = new lib.pseudo();
	this.instance.setTransform(1560.45,1097.15);

	this.instance_1 = new lib.pseudo();
	this.instance_1.setTransform(1720.15,1097.15,0.7478,1);

	this.instance_2 = new lib.pseudo();
	this.instance_2.setTransform(1852.1,1097.15,0.6031,1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// title
	this.instance_3 = new lib.title();
	this.instance_3.setTransform(360,1026);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// logo
	this.occ_logo = new lib.logo_1();
	this.occ_logo.name = "occ_logo";
	this.occ_logo.setTransform(60,1000);
	this.occ_logo.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_logo).wait(1));

	// background
	this.instance_4 = new lib.background();
	this.instance_4.setTransform(0,1000);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(1));

	// background_dynamic
	this.occ_dynamic = new lib.background_dynamic();
	this.occ_dynamic.name = "occ_dynamic";
	this.occ_dynamic.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_dynamic).wait(1));

	// size
	this.instance_5 = new lib.size_1920x1080();

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.content_frame_02, new cjs.Rectangle(-2,0,1935.4,1170), null);


// stage content:
(lib.index = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"frame01":1,"frame02":2};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.actionFrames = [0,1];
	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.frame01Index(this, 'index');
	}
	this.frame_1 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(2));

	// ContentFrame
	this.occ_frame_01 = new lib.content_frame_01();
	this.occ_frame_01.name = "occ_frame_01";

	this.occ_frame_02 = new lib.content_frame_02();
	this.occ_frame_02.name = "occ_frame_02";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.occ_frame_01}]},1).to({state:[{t:this.occ_frame_02}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1933.4,1170);
// library properties:
lib.properties = {
	id: '8D6FF2B23DC06844BB2994587C24925D',
	width: 1920,
	height: 1080,
	fps: 30,
	color: "#FFFFFF",
	opacity: 0.00,
	manifest: [
		{src:"./images/CachedBmp_14.png?1725199000052", id:"CachedBmp_14"},
		{src:"./images/CachedBmp_13.png?1725199000052", id:"CachedBmp_13"},
		{src:"./images/index_atlas_1.png?1725199000012", id:"index_atlas_1"}
	],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['8D6FF2B23DC06844BB2994587C24925D'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = document.documentElement.clientWidth, ih = document.documentElement.clientHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
